import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';
import * as _ from 'lodash';
import * as moment from 'moment';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { UserService } from 'app/shared/services/user.service';

@AutoUnsubscribe()
@Component({
  selector: 'legacy-publisher-reports',
  templateUrl: './legacy-publisher-reports.component.html',
  styleUrls: ['./legacy-publisher-reports.component.scss'],
})
export class LegacyPublisherReportsComponent implements OnInit {
  public isLegacyPublishers: boolean;
  public reports: Array<any>;
  public currReport: number;
  public previousReport: number;
  public data: Array<any>;
  public dataTotal: any;
  public columnsSettings: Array<any>;
  public allSupplies: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public isExporting: boolean;
  public startDate: Date;
  public endDate: Date;
  public filters: any;
  public sorting: any;
  public playerId: string;
  public subIds: Array<string>;
  public subId: string;
  public queryParams: any;
  public itemsPerPage: number;
  public currSubscription: Subscription;
  public subscriptions: Array<Subscription>;
  public defaultEndpoint: string;
  public defaultSorting: any;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public httpService: HttpService,
    public gridService: GridService,
    public dictionaryService: DictionaryService,
    public userService: UserService
  ) {
    this.reports = [
      {
        filterBy: null,
        title: 'ALL_INVENTORY',
        reportName: 'ALL_INVENTORY',
        url: 'publisher/getReport',
        columnsSettings: [
          { key: 'name', label: 'NAME', filterType: 'INPUT', width: 350, disableHide: true },
          {
            key: 'adStarts',
            label: 'IMPRESSIONS',
            tooltipKey: 'REPORT_TOOLTIP_I',
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
          {
            key: 'cost',
            label: 'REVENUE',
            tooltipKey: 'REPORT_TOOLTIP_R',
            decimal: true,
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
        ],
        linkColumns: ['name'],
        sortColumn: 'cost',
        sortOrder: 'desc',
        showSubIdSearchBox: false,
        hideInDropdown: true,
      },
      {
        filterBy: 'day',
        title: 'BY_DAY',
        reportName: 'INVENTORY_BY_DAY',
        url: 'publisher/getReportByDay/range',
        columnsSettings: [
          { key: 'day', label: 'DAY', filterType: 'INPUT', width: 350, disableHide: true },
          {
            key: 'adStarts',
            label: 'IMPRESSIONS',
            tooltipKey: 'REPORT_TOOLTIP_I',
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
          {
            key: 'cost',
            label: 'REVENUE',
            tooltipKey: 'REPORT_TOOLTIP_R',
            decimal: true,
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
        ],
        linkColumns: [],
        sortColumn: 'cost',
        sortOrder: 'desc',
        showSubIdSearchBox: false,
        hideInDropdown: false,
      },
      {
        filterBy: 'domains',
        title: 'BY_DOMAIN',
        reportName: 'INVENTORY_BY_DOMAIN',
        url: 'publisher/getReportByDomain/range',
        columnsSettings: [
          { key: 'domain', label: 'DOMAIN', filterType: 'INPUT', width: 350, disableHide: true },
          {
            key: 'adStarts',
            label: 'IMPRESSIONS',
            tooltipKey: 'REPORT_TOOLTIP_I',
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
          {
            key: 'cost',
            label: 'REVENUE',
            tooltipKey: 'REPORT_TOOLTIP_R',
            decimal: true,
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
        ],
        linkColumns: [],
        sortColumn: 'cost',
        sortOrder: 'desc',
        showSubIdSearchBox: true,
        hideInDropdown: false,
      },
      {
        filterBy: 'sid',
        title: 'BY_SUB_ID',
        reportName: 'INVENTORY_BY_SUBID',
        url: 'publisher/getReportBySubId/range',
        columnsSettings: [
          { key: 'subid', label: 'SUB_ID', filterType: 'INPUT', width: 350, disableHide: true },
          {
            key: 'adStarts',
            label: 'IMPRESSIONS',
            tooltipKey: 'REPORT_TOOLTIP_I',
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
          {
            key: 'cost',
            label: 'REVENUE',
            tooltipKey: 'REPORT_TOOLTIP_R',
            decimal: true,
            rightAligned: true,
            filterType: 'RANGE',
            aggregated: 'aggregateSum',
          },
        ],
        linkColumns: [],
        sortColumn: 'cost',
        sortOrder: 'desc',
        showSubIdSearchBox: true,
        hideInDropdown: false,
      },
    ];
    this.isLegacyPublishers = true;
    this.currReport = 0;
    this.previousReport = null;
    this.columnsSettings = [];
    this.allSupplies = [];
    this.isLoading = false;
    this.isError = false;
    this.isExporting = false;
    if (!this.sharedService.isEmpty(localStorage.getItem('selectedDates'))) {
      const savedDates: any = JSON.parse(localStorage.getItem('selectedDates'));
      this.startDate = new Date(savedDates.startDate);
      this.endDate = new Date(savedDates.endDate);
    } else {
      this.startDate = new Date();
      this.endDate = new Date();
    }
    this.filters = {};
    this.playerId = null;
    this.subIds = [];
    this.subId = null;
    this.itemsPerPage = 50;
    this.subscriptions = new Array<Subscription>();
    this.defaultEndpoint = '/inventory-all';
    this.defaultSorting = {
      sortColumn: 'cost',
      sortOrder: 'desc',
    };
    this.sorting = _.cloneDeep(this.defaultSorting);
  }

  ngOnDestroy() {}

  ngOnInit() {
    if (this.userService.userData.userType !== 'publisher') {
      this.router.navigate([this.userService.getDefaultRoute()]);
      return;
    }

    this.route.queryParams.subscribe((queryParams: any) => {
      this.queryParams = _.cloneDeep(queryParams);
      this.parseQueryParams();
    });
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.playerId = null;
          this.currReport = 0;
          this.getReport();
        } else if (response.type === 'SUB_ID_SEARCH') {
          this.subIds = _.without(response.data.split(','), '');
          this.getReport();
        }
      })
    );
    this.getReport();
    this.sharedService.setPageTitle('ALL_INVENTORY');
  }

  getReport() {
    const queryParams: any = {
      sd: moment(this.startDate).format('YYYY-MM-DD').toString(),
      ed: moment(this.endDate).format('YYYY-MM-DD').toString(),
    };
    if (this.currReport !== 0) {
      queryParams.by = this.reports[this.currReport].filterBy;
    }
    if (this.sharedService.isEmptyObj(this.sorting)) {
      if (this.reports[this.currReport].sortColumn && this.reports[this.currReport].sortOrder) {
        queryParams.s = `${this.reports[this.currReport].sortColumn},${this.reports[this.currReport].sortOrder}`;
      } else {
        queryParams.s = `${this.defaultSorting.sortColumn},${this.defaultSorting.sortOrder}`;
      }
    }
    if (!this.sharedService.isEmpty(this.playerId)) {
      queryParams.id = this.playerId;
    }
    if (this.subIds.length > 0) {
      queryParams.subIds = this.subIds.join(',');
    }
    if (!this.sharedService.isEmpty(this.subId)) {
      queryParams.subId = this.subId;
    }

    this.router.navigate([], { queryParams: queryParams });
  }

  parseQueryParams() {
    const observables: Array<Observable<any>> = [];
    let reportByURL = '';
    this.isLoading = true;
    this.sharedService.sendMessage('GRID_DETECT_CHANGES');
    if (this.queryParams.sd) {
      this.startDate = new Date(this.queryParams.sd);
    }
    if (this.queryParams.ed) {
      this.endDate = new Date(this.queryParams.ed);
    }
    if (this.queryParams.by) {
      this.currReport = _.findIndex(this.reports, { filterBy: this.queryParams.by });
      if (this.currReport === -1) {
        this.currReport = 0;
      }
    } else {
      this.currReport = -1;
      reportByURL = this.router.url.split('/').pop();
      if (reportByURL && reportByURL.length) {
        reportByURL = this.router.url.split('-by-').pop();
        if (reportByURL && reportByURL.length) {
          this.currReport = _.findIndex(this.reports, { filterBy: reportByURL.split('?')[0] });
        }
      }
      if (this.currReport === -1) { this.currReport = 0; }
    }
    if (this.previousReport !== this.currReport) {
      // Reset the filters
      this.resetFilters();
      // Reset sorting
      this.sorting = _.cloneDeep(this.defaultSorting);
    }
    if (this.sharedService.isEmptyObj(this.sorting)) {
      if (this.reports[this.currReport].sortColumn && this.reports[this.currReport].sortOrder) {
        this.sorting = {
          sortColumn: this.reports[this.currReport].sortColumn,
          sortOrder: this.reports[this.currReport].sortOrder,
        };
      } else {
        this.sorting = _.cloneDeep(this.defaultSorting);
      }
    }

    this.previousReport = this.currReport;
    if (this.queryParams.id) {
      this.playerId = this.queryParams.id;
    } else {
      this.playerId = null;
    }
    if (this.queryParams.subIds) {
      this.subIds = this.queryParams.subIds.split(',');
    } else {
      this.subIds = [];
    }
    if (this.queryParams.subId && this.currReport === 8) {
      this.subId = this.queryParams.subId;
    } else {
      this.subId = null;
    }
    observables.push(this.getReportData());
    if (this.currReport !== 0 && this.allSupplies.length === 0) {
      observables.push(this.getAllSupplies());
    }
    if (this.currSubscription) {
      this.currSubscription.unsubscribe();
    }
    this.currSubscription = forkJoin(observables).subscribe(
      (response: any) => {
        let data: Array<any> = [];
        const allSuppliesResponse: Array<any> =
          response.length > 1 ? _.sortBy(response[1], (item: any) => item.name) : [];
        const allSupplies: Array<any> = [];
        let datesParams: string;

        // Error validation
        this.isError = false;
        this.dataTotal = {};
        if (response[0].errors) {
          this.isError = true;
        } else {
          // If there's a networkData attribute, we'll check if we need to change the network
          if (response[0].networkData) {
            this.userService.changeNetworkIfNeeded(response[0]);
          }
          // If there's any data at all...

          if (
            (this.currReport === 0 && response[0].length > 0) ||
            (this.currReport !== 0 && response[0].result.length > 0)
          ) {
            // Parse the data
            data = data.concat(this.currReport === 0 ? response[0] : response[0].result);
            data.forEach((item: any) => {
              if (this.sharedService.getNumOfKeys(item) > 0) {
                datesParams =
                  '?sd=' +
                  moment(this.startDate).format('YYYY-MM-DD').toString() +
                  '&ed=' +
                  moment(this.endDate).format('YYYY-MM-DD').toString();
                switch (this.currReport) {
                  case 0:
                    item.$$link = this.defaultEndpoint + datesParams + '&id=' + item.playerId + '&by=day';
                    break;
                  case 1:
                  case 2:
                    item.$$link = this.defaultEndpoint + datesParams + '&id=' + item.playerId + '&by=day';
                    break;
                  case 6:
                    item.$$link =
                      this.defaultEndpoint +
                      datesParams +
                      '&id=' +
                      this.playerId +
                      '&subId=' +
                      item.subid +
                      '&by=demandSubId';
                    break;
                }
              }
            });
          }
          // All supplies
          allSuppliesResponse.forEach((item: any) => {
            allSupplies.push({ label: item.name, value: parseInt(item.playerId) });
          });
          // Update the columns settings
          this.updateColumnsSettings();
          // Pass the data
          this.data = data;
          this.calculateTotals();
          if (allSupplies.length > 0) {
            this.allSupplies = allSupplies;
          }
        }
        this.isLoading = false;
        this.sharedService.sendMessage('GRID_DETECT_CHANGES');
      },
      (error: any) => {
        this.isError = true;
      }
    );
    this.subscriptions.push(this.currSubscription);
  }

  getReportData() {
    const startDate: Date = new Date(_.cloneDeep(this.startDate).setHours(0, 0, 0, 0));
    const endDate: Date = new Date(_.cloneDeep(this.endDate).setHours(23, 59, 59, 0));
    const queryParams: any = {
      startDate: startDate.toString(),
      endDate: endDate.toString(),
      filters: this.parseFilters(),
    };
    if (this.sorting.sortColumn) {
      if (_.find(this.columnsSettings, { key: this.sorting.sortColumn })) {
        queryParams.sorting = this.sorting;
      } else {
        this.sorting = _.cloneDeep(this.defaultSorting);
      }
    }
    if (this.currReport !== 0) {
      queryParams.playerId = this.playerId;
      if (this.subIds.length > 0) {
        queryParams.subids = this.subIds;
      }
    }
    if (this.currReport === 8) {
      queryParams.subid = this.subId;
    }
    return this.httpService.post(this.reports[this.currReport].url, queryParams);
  }

  getAllSupplies() {
    return this.httpService.post('publisher/getAllPlayers', { playerName: 'all' });
  }

  updateColumnsSettings() {
    this.columnsSettings = _.cloneDeep(this.reports[this.currReport].columnsSettings);
  }

  parseFilters() {
    const filters: any = _.cloneDeep(this.filters);
    if (filters.player_type) {
      if (filters.player_type.length > 0) {
        filters.player_type = filters.player_type[0];
      }
    }
    if (filters.vast_type) {
      if (filters.vast_type.length > 0) {
        filters.vast_type = filters.vast_type[0];
      }
    }
    return filters;
  }

  resetFilters() {
    const filters: any = {};
    this.columnsSettings.forEach((column: any) => {
      if (column.filterType) {
        if (column.filterType === 'INPUT') {
          filters[column.key] = '';
        } else if (column.filterType === 'SELECT') {
          filters[column.key] = [];
        }
      }
    });
    this.filters = _.cloneDeep(filters);
  }

  startDateChanged($event: any) {
    this.startDate = $event;
  }

  endDateChanged($event: any) {
    this.endDate = $event;
    if ($event) {
      this.getReport();
    }
  }

  onFilterByChange($event: any) {
    this.currReport = _.findIndex(this.reports, { filterBy: $event });
    this.resetFilters();
    this.getReport();
  }

  onSupplyChange($event: any) {
    this.playerId = $event.value;
    this.getReport();
  }

  // On filter change
  onFilterChange($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    const newFilters: any = _.cloneDeep($event);
    this.filters = _.cloneDeep(newFilters);
    if (queryParams.p === undefined) {
      queryParams.p = '1';
    }
    if (queryParams.p.toString() === '1') {
      this.parseQueryParams();
    } else {
      queryParams.p = '1';
      this.router.navigate([], { queryParams: queryParams });
    }
  }

  // On sort change
  onSortChange($event: any) {
    this.sorting = {
      sortColumn: $event.sortCell,
      sortOrder: $event.sortDir,
    };
    this.sharedService.sendMessage('GRID_REDRAW');
  }

  // Unselect the selected sub ID
  removeSubId() {
    this.subId = null;
    this.currReport = 6;
    this.getReport();
  }

  // Get the URL for the previous page
  getBackURL() {
    const url: any = { link: this.defaultEndpoint, queryParams: _.cloneDeep(this.queryParams) };
    delete url.queryParams.id;
    delete url.queryParams.by;
    delete url.queryParams.subIds;
    return url;
  }

  // Get the selected entity's index
  getSelectedSupplyIndex() {
    return _.findIndex(this.allSupplies, (item: any) => {
      return item.value === parseInt(this.playerId);
    });
  }

  //Calculate Totals
  calculateTotals() {
    let columnsSettings: Array<any> = _.cloneDeep(this.reports[this.currReport].columnsSettings);
    this.dataTotal = {};
    columnsSettings = _.map(columnsSettings, (one: any) => {
      return one.hasOwnProperty('aggregated') ? one : false;
    });
    columnsSettings.forEach((one: any) => {
      if (one && one.key && one.aggregated) {
        if (typeof this.gridService[one.aggregated] === 'function') {
          this.dataTotal[one.key] = this.gridService[one.aggregated](this.data, one.key);
        }
      }
    });
  }
}
